import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * `cn` — class-name merge helper used throughout `@jumpstone/ui-react`.
 *
 * Wraps `clsx` (conditional class joining) with `tailwind-merge` (deduplicates
 * conflicting Tailwind utilities, e.g. `p-2 p-4` → `p-4`).
 *
 * Re-exported from `@jumpstone/ui-react` so app code that builds on these
 * primitives doesn't need its own helper.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
